function injectStyle (ssrContext) {
  require("!!vue-style-loader!cache-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3c18eae6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./remote-wrapper.vue")
}
var normalizeComponent = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!cache-loader!happypack/loader?id=babel!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./remote-wrapper.vue"
import __vue_script__ from "!!cache-loader!happypack/loader?id=babel!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./remote-wrapper.vue"
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c18eae6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/my-workbench/remote-wrapper.vue
// module id = null
// module chunks = 